"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
export default function Airconditioningfaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const faqs = [{
    question: "How often should I service my AC unit?",
    answer: "We recommend professional servicing at least once a year to ensure optimal efficiency and air quality. Regular maintenance helps prevent unexpected breakdowns, extends the lifespan of your system, and keeps your energy bills under control throughout the summer months."
  }, {
    question: "Do you provide commercial services?",
    answer: "Yes, Coastline Air Conditioning Services specializes in comprehensive climate control solutions for commercial environments. From office buildings to retail spaces, our team provides tailored installation, maintenance, and repair services to keep your business environment comfortable and productive."
  }, {
    question: "What areas do you cover?",
    answer: "Our expert technicians provide high-quality air conditioning services across Sussex and Surrey. Whether you are in a residential home or a commercial facility, we are committed to delivering prompt and reliable climate control support throughout these regions."
  }, {
    question: "How can I improve energy efficiency?",
    answer: "Improving efficiency starts with regular filter cleaning and ensuring your thermostat is correctly calibrated. We also offer modern, energy-efficient system upgrades that can significantly reduce your carbon footprint and long-term operational costs."
  }, {
    question: "Can you install systems in older homes?",
    answer: "Absolutely. We have extensive experience installing modern air conditioning systems in period properties and older homes. We prioritize discreet, non-invasive installation methods to preserve the character of your property while providing modern climate comfort."
  }];
  return <section data-section-id="4475" id="airconditioningfaq" className="bg-slate-50 text-slate-900 py-24 md:py-32 px-6 md:px-12 lg:px-20">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <p className="font-default text-xs uppercase tracking-widest text-blue-700 mb-8">
                — Expert Guidance
              </p>
              <h2 className="font-default text-4xl md:text-5xl lg:text-5xl leading-[1.05] tracking-tight text-slate-900">
                Common
                <br />
                <span className="italic text-blue-600">questions.</span>
              </h2>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 lg:col-start-6">
            <div className="border-t border-slate-200">
              <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-b border-slate-200 last:border-b-0 group">
                    <AccordionTrigger className="py-8 hover:no-underline text-left [&>svg]:hidden [&[data-state=open]_.faq-icon]:rotate-45 [&[data-state=open]_.faq-icon]:text-blue-600 [&[data-state=open]_.faq-question]:translate-x-1">
                      <span className="faq-question font-default text-xl md:text-2xl text-slate-900 transition-transform duration-300 ease-out group-hover:translate-x-1 leading-snug pr-6">
                        {faq.question}
                      </span>
                      <span aria-hidden="true" className="faq-icon shrink-0 text-slate-400 transition-all duration-300 ease-out group-hover:text-blue-600 text-2xl font-light leading-none mt-1">
                        +
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="pb-8 pt-0">
                      <p className="font-default text-base text-slate-600 leading-[1.7] max-w-[600px]">
                        {faq.answer}
                      </p>
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>
            </div>

            {}
            <div className="mt-16 pt-8 border-t border-slate-200">
              <p className="font-default text-xs uppercase tracking-widest text-slate-500">
                Need more help?{" "}
                <span className="mx-2 text-slate-300">→</span>
                <Link to="/AirConditioningPage" className="relative inline-block text-blue-700 hover:text-blue-800 transition-colors duration-300 group/link">
                  info@coastline-services.co.uk
                  <span className="absolute left-0 -bottom-0.5 h-px w-full bg-current origin-left scale-x-100 transition-transform duration-500 ease-out group-hover/link:scale-x-0" />
                  <span className="absolute left-0 -bottom-0.5 h-px w-full bg-blue-600 origin-right scale-x-0 transition-transform duration-500 ease-out group-hover/link:origin-left group-hover/link:scale-x-100" />
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}